import { TreeNode } from '@/types/tree';

/**
 * Whether a tree node should expand when the user clicks its label (or selects it via the tree).
 * All expandable nodes (samples, containers, publication activities, etc.) expand on click.
 */
export function nodeExpandsOnSelect(node: Pick<TreeNode, 'isExpandable'>): boolean {
  return node.isExpandable;
}
